export class ReferenceValue {
  constructor(
    public type: string,
    public stepRule: number,
    public fixPrice: number,
    public pricePerUnit: number,
    public range: string,
    public calculation: string,
  ) { }
}